import {expose} from "@/ts/utilities";

export interface SelectOptions {
    title?: string;
    placeholder?: string;
    enableSearch?: boolean;
    removeText?: string;
    applyText?: string;
    noMatches?: string;
    isMulti?: boolean;
}

//Module that initialize a multi select, and render it as a custom select, with a custom style, where in the panel you can search for an option,
//select it, and it will be shown under the select opener button;
export module SearchableSelect {
    const $selects = document.querySelectorAll('select[data-select-search]');

    function bindSelect($select: any, index: any, selectOptions: any) {
        const $options = $select.querySelectorAll('option');
        const $parentElement = $select.parentElement;

        if ($parentElement && $parentElement.hasAttribute('data-select-up-search') && !$parentElement.querySelector('.search-select__container')) {
            if (!selectOptions.isMulti) {
                $parentElement.classList.add('single');
            }

            const multiSelectTitle = document.createElement('div');
            if (selectOptions.title) {
                multiSelectTitle.classList.add('search-select__title');
                multiSelectTitle.innerText = selectOptions.title;
            }

            const container = document.createElement('div');
            container.classList.add('search-select__container');
            const buttonOpener = document.createElement('button');

            buttonOpener.setAttribute('aria-haspopup', 'listbox');
            buttonOpener.setAttribute('aria-expanded', 'false');
            buttonOpener.setAttribute('type', 'button');
            $parentElement.hasAttribute('data-disabled') && buttonOpener.setAttribute('disabled', '');
            buttonOpener.classList.add('search-select__opener');
            if (selectOptions.isMulti) {
                buttonOpener.innerHTML = selectOptions.isMulti && selectOptions.placeholder ? selectOptions.placeholder : 'Apri';
            } else {
                let dataFront = $select.options[$select.selectedIndex] && $select.options[$select.selectedIndex].getAttribute('data-front')
                    ? $select.options[$select.selectedIndex].getAttribute('data-front')
                    : $select.options[$select.selectedIndex]
                        ? $select.options[$select.selectedIndex].innerText
                        : $select.value;
                buttonOpener.innerHTML = dataFront;
            }

            const panel = document.createElement('div');
            panel.classList.add('search-select__panel');
            if ($select.value && $select.value !== 'placeholder') {
                panel.classList.add('applied');
            }
            panel.setAttribute('role', 'listbox');
            panel.setAttribute('panel-id', `multi-select-${index}`);
            const selectionContainer = document.createElement('div');
            selectionContainer.classList.add('selection-container');
            const $selectOptionsSelected = $select.querySelectorAll('option[selected]');
            const buttons = document.createElement('div');
            const resetSelect = document.createElement('button');
            const applySelect = document.createElement('button');
            const input = document.createElement('input');

            if (selectOptions.isMulti) {
                const label = document.createElement('label');
                const inputWrapper = document.createElement('div');
                const closeIcn = document.createElement('div');
                closeIcn.classList.add('close-icn');
                closeIcn.classList.add('d-none');
                closeIcn.setAttribute('role', 'button');
                inputWrapper.classList.add('input-wrapper');
                input.setAttribute('id', `multi-select-${index}`);
                input.setAttribute('type', 'text');
                input.setAttribute('disabled', '');
                input.classList.add('panel-input');
                input.classList.add('skip-style');
                input.classList.add('focus-mouse');
                input.setAttribute('placeholder', Drupal.t('Cerca'));
                label.classList.add('d-none');
                label.setAttribute('for', `multi-select-${index}`);
                inputWrapper.appendChild(label);
                inputWrapper.appendChild(input);
                inputWrapper.appendChild(closeIcn);
                panel.appendChild(inputWrapper)
                resetSelect.classList.add('reset-select');
                applySelect.classList.add('apply-select');
                resetSelect.setAttribute('disabled', '');
                applySelect.setAttribute('disabled', '');
                applySelect.innerText = selectOptions.applyText ? selectOptions.applyText : 'Applica';
                resetSelect.innerText = selectOptions.removeText ? selectOptions.removeText : 'Rimuovi tutti';
                buttons.appendChild(resetSelect);
                buttons.appendChild(applySelect);
                buttons.classList.add('buttons');
            }

            const optionWrapper = document.createElement('div');
            optionWrapper.classList.add('option-wrapper');

            $options.forEach(($option: any) => {
                const optionDiv = document.createElement('div');
                const dataFront = $option.getAttribute('data-front');
                const dataValue = $option.getAttribute('data-value');
                const dataType = $option.getAttribute('data-type');
                optionDiv.setAttribute('role', 'option');

                if (dataFront) {
                    optionDiv.setAttribute('data-front', dataFront);
                }

                if (dataType) {
                    optionDiv.setAttribute('data-type', dataType);
                }

                if (dataValue) {
                    optionDiv.setAttribute('data-value', dataValue);
                }

                if (selectOptions.isMulti) {
                    const tickBox = document.createElement('div');
                    tickBox.classList.add('checkbox');
                    tickBox.setAttribute('role', 'checkbox');
                    tickBox.setAttribute('aria-checked', 'false');
                    tickBox.setAttribute('aria-labelledby', $option.innerText);
                    tickBox.setAttribute('tabindex', '-1');
                    tickBox.setAttribute('option-id', $option.value);
                    if($option.selected){
                        tickBox.setAttribute('aria-checked', 'true');
                    }
                    optionDiv.appendChild(tickBox);
                } else {
                    if ($option.selected) {
                        optionDiv.setAttribute('aria-selected', 'true');
                    } else {
                        optionDiv.setAttribute('aria-selected', 'false');
                    }

                    optionDiv.setAttribute('tabindex', '-1');
                }

                const text = document.createElement('div');
                if(selectOptions.isMulti){
                    text.setAttribute('id', $option.innerText);
                }
                text.classList.add('text');
                text.innerText = $option.innerText;
                optionDiv.appendChild(text);

                if ($option.selected) {
                    optionDiv.classList.add('selected');
                }
                optionDiv.classList.add('option-div');
                optionDiv.setAttribute('option-id', $option.value);

                optionWrapper.appendChild(optionDiv);
            });

            buttonOpener.addEventListener('click', (e: any) => {
                togglePanel(panel, selectOptions, buttonOpener, e, $options);
            });

            buttonOpener.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Alt') {
                    togglePanel(panel, selectOptions, buttonOpener, e, $options);
                }
            })

            panel.appendChild(optionWrapper);

            const noResultDiv = document.createElement('div');
            if (selectOptions.isMulti) {
                noResultDiv.classList.add('no-result-el');
                noResultDiv.classList.add('d-none');
                noResultDiv.innerHTML = selectOptions.noMatches ? selectOptions.noMatches : Drupal.t('Nessuna corrispondenza');
                panel.appendChild(noResultDiv);
                panel.appendChild(buttons);
                if (!$selectOptionsSelected.length) {
                    selectionContainer.classList.add('d-none');
                } else {
                    bindShowSelection(selectionContainer, $select.querySelectorAll('option'), panel);
                }
            } else {
                selectionContainer.classList.add('d-none');
            }

            bindChange(panel, $options, selectOptions.isMulti, $select, buttonOpener);

            if (selectOptions.isMulti) {
                bindInput(panel);
                bindApply(panel, $options, selectionContainer, $select, buttonOpener);
                bindReset(panel, $options, selectionContainer, $select, buttonOpener);
                bindRemoveSingleSelection(panel, $options, selectionContainer, $select);
            }
            bindNextTab(panel, selectOptions.isMulti, buttonOpener, $select);

            bindClosePanel(panel, buttonOpener, $select);
            bindArrowPanel(panel);

            container.appendChild(panel);
            container.appendChild(buttonOpener);
            container.appendChild(selectionContainer);

            if (selectOptions.title) {
                $parentElement.appendChild(multiSelectTitle);
            }

            $parentElement.appendChild(container);
        }
    }

    function bindChange(panel: any, $options: any, isMulti: boolean, $select: any, $opener: any) {
        if (isMulti) {
            const divOptions = panel.querySelectorAll('.option-div');
            const resetSelect = panel.querySelector('.reset-select');
            const applySelect = panel.querySelector('.apply-select');
            let optionPreSel = 0;

            divOptions.forEach((divOption: any) => {
                const divId = divOption.getAttribute('option-id');

                const checkbox = divOption.querySelector('.checkbox');

                checkbox.addEventListener('click', () => {
                    let remove = false;

                    if (divOption.classList.contains('selected')) {
                        checkbox.setAttribute('aria-checked', 'false');
                        divOption.classList.remove('selected');
                        divOption.removeAttribute('aria-selected');
                        remove = true;
                        optionPreSel--;
                    } else {
                        checkbox.setAttribute('aria-checked', 'true');
                        divOption.classList.add('selected');
                        divOption.setAttribute('aria-selected', 'true');
                        optionPreSel++;
                    }

                    $options.forEach(($option: any) => {
                        if ($option.value === divId) {
                            $option.selected = !remove;
                        }
                    });

                    if (optionPreSel) {
                        resetSelect.removeAttribute('disabled');
                        applySelect.removeAttribute('disabled');
                    } else {
                        resetSelect.setAttribute('disabled', '');
                        applySelect.setAttribute('disabled', '');
                    }
                });

                checkbox.addEventListener('keyup', (e: any) => {
                    if (e.key === 'Enter') {
                        let remove = false;

                        if (divOption.classList.contains('selected')) {
                            checkbox.setAttribute('aria-checked', 'false');
                            divOption.removeAttribute('aria-selected');
                            divOption.classList.remove('selected');
                            remove = true;
                            optionPreSel--;
                        } else {
                            checkbox.setAttribute('aria-checked', 'true');
                            divOption.setAttribute('aria-selected', 'true');
                            divOption.classList.add('selected');
                            optionPreSel++;
                        }

                        $options.forEach(($option: any) => {
                            if ($option.value === divId) {
                                $option.selected = !remove;
                            }
                        });

                        if (optionPreSel) {
                            resetSelect.removeAttribute('disabled');
                            applySelect.removeAttribute('disabled');
                        } else {
                            resetSelect.setAttribute('disabled', '');
                            applySelect.setAttribute('disabled', '');
                        }
                    }
                });
            });
        } else {
            const divOptions = panel.querySelectorAll('.option-div');
            divOptions.forEach((divOption: any) => {

                divOption.addEventListener('click', () => {
                    const divId = divOption.getAttribute('option-id');
                    divOption.classList.add('selected');
                    divOption.setAttribute('aria-selected', 'true');
                    panel.classList.add('applied');

                    divOptions.forEach((dO: any) => {
                        const dId = dO.getAttribute('option-id');
                        dO.setAttribute('tabindex', '-1');
                        if (dId !== divId) {
                            dO.classList.remove('selected');
                            dO.setAttribute('aria-selected', 'false');
                        }
                    });

                    $options.forEach(($option: any) => {
                        let dataFront = $option.getAttribute('data-front');
                        if ($option.value === divId) {
                            $option.selected = true;
                            $opener.innerText = dataFront ? dataFront : $option.innerText;
                        } else {
                            $option.selected = false;
                        }

                    });

                    $select.dispatchEvent(new Event('change'));
                    panel.classList.remove('visible');
                    panel.setAttribute('tabindex', '-1');
                    $opener.classList.remove('open');
                    $opener.setAttribute('aria-expanded', 'false');

                });

                divOption.addEventListener('keyup', (e: KeyboardEvent) => {
                    const divId = divOption.getAttribute('option-id');
                    if (e.key === 'Enter') {
                        divOption.classList.add('selected');
                        divOption.setAttribute('aria-selected', 'true');
                        panel.classList.add('applied');

                        divOptions.forEach((dO: any) => {
                            const dId = dO.getAttribute('option-id');
                            dO.setAttribute('tabindex', '-1');
                            if (dId !== divId) {
                                dO.classList.remove('selected');
                                dO.setAttribute('aria-selected', 'false');
                            }
                        });

                        $options.forEach(($option: any) => {
                            let dataFront = $option.getAttribute('data-front');
                            if ($option.value === divId) {
                                $option.selected = true;
                                $opener.innerText = dataFront ? dataFront : $option.innerText;
                            } else {
                                $option.selected = false;
                            }

                        });

                        $select.dispatchEvent(new Event('change'));
                        panel.classList.remove('visible');
                        panel.setAttribute('tabindex', '-1');
                        $opener.classList.remove('open');

                    }
                });
            });
        }
    }

    function bindShowSelection(selectionContainer: any, $options: any, panel: any) {
        $options.forEach(($option: any) => {
            if ($option.selected) {
                if (!selectionContainer.querySelector(`div[option-id="${$option.value}"]`)) {
                    const selectionDiv = document.createElement('div');
                    const deleteIcn = document.createElement('div');
                    const text = document.createElement('div');

                    deleteIcn.classList.add('delete-icn');
                    deleteIcn.setAttribute('tabindex', '0');
                    text.classList.add('text');
                    selectionDiv.classList.add('selection');
                    selectionDiv.setAttribute('option-id', $option.value);
                    text.innerText = $option.innerText;
                    deleteIcn.setAttribute('option-id', $option.value);

                    selectionDiv.appendChild(text);
                    selectionDiv.appendChild(deleteIcn);

                    selectionContainer.appendChild(selectionDiv);
                }
            } else {
                if (selectionContainer.querySelector(`div[option-id="${$option.value}"]`)) {
                    const divFound = selectionContainer.querySelector(`div[option-id="${$option.value}"]`);
                    divFound.remove();
                }
            }
        })

        const resetBtn = panel.querySelector('.reset-select');

        if (isResetEnabled($options)) {
            resetBtn.removeAttribute('disabled');
        } else {
            resetBtn.setAttribute('disabled', '');
        }
    }

    function bindInput(panel: any) {
        const input = panel.querySelector('.input-wrapper input');
        const closeIcn = panel.querySelector('.input-wrapper .close-icn');
        const options = panel.querySelectorAll('.option-div');
        const noResult = panel.querySelector('.no-result-el');
        const applyBtn = panel.querySelector('.apply-select');

        input.addEventListener('input', () => {
            if (input.value && input.value.length > 0) {
                closeIcn.classList.remove('d-none');
                closeIcn.setAttribute('tabindex', '0');
            } else {
                closeIcn.classList.add('d-none');
                closeIcn.setAttribute('tabindex', '-1');
            }

            bindSearch(options, closeIcn, input, noResult, applyBtn);
            bindCloseIcn(options, closeIcn, input, noResult, applyBtn);

        });

        input.addEventListener('keyup', (e: KeyboardEvent) => {
            if (e.key === 'Tab' && input.classList.contains('focus-mouse')) {
                input.classList.remove('focus-mouse');
            }
        });

        input.addEventListener('focusout', () => {
            input.classList.add('focus-mouse');
        });
    }

    function clearInput(input: any, options: any) {
        options.forEach((option: any) => {
            option.classList.remove('d-none');
        });

        if (input && input.value) {
            input.value = '';
        }
    }

    function bindCloseIcn(options: any, closeIcn: any, input: any, noResult: any, applyBtn: any) {
        closeIcn.onclick = () => {
            closeIcn.setAttribute('tabindex', '-1');
            closeIcn.classList.add('d-none');
            input.focus();
            clearInput(input, options);
            noResult.classList.add('d-none');
            applyBtn.removeAttribute('disabled');
        }

        closeIcn.onkeyup = (e: any) => {
            if (e.key === 'Enter') {
                closeIcn.setAttribute('tabindex', '-1');
                closeIcn.classList.add('d-none');
                input.focus();
                input.classList.remove('focus-mouse');
                clearInput(input, options);
                noResult.classList.add('d-none');
                applyBtn.removeAttribute('disabled');
            }
        }
    }

    function bindSearch(options: any, closeIcn: any, input: any, noResult: any, applyBtn: any) {
        let found = false;
        if (input.value) {
            options.forEach((option: any) => {
                if (!option.innerText.toLowerCase().includes(input.value.toLowerCase())) {
                    option.classList.add('d-none');
                } else {
                    option.classList.remove('d-none');
                    found = true;
                }
            })
        } else {
            found = true;
            clearInput(input, options);
            closeIcn.setAttribute('tabindex', '-1');
            closeIcn.classList.add('d-none');
        }

        if (!found) {
            noResult.classList.remove('d-none');
            applyBtn.setAttribute('disabled', '');
        } else {
            applyBtn.removeAttribute('disabled');
            noResult.classList.add('d-none');
        }
    }

    function bindClosePanel(panel: any, buttonOpener: any, $select: any) {

        document.addEventListener('keyup', (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                closePanel(panel, buttonOpener, $select);
            }
        });

        document.addEventListener('click', (e: any) => {
            if (!panel.contains(e.target) && e.target !== buttonOpener) {
                closePanel(panel, buttonOpener, $select);
            }
        });
    }

    function bindApply(panel: any, options: any, selectionContainer: any, $select: any, opener: any) {
        const applyBtn = panel.querySelector('.buttons .apply-select');

        applyBtn.addEventListener('click', () => {
            panel.classList.add('applied');
            opener.classList.remove('open');
            panel.classList.remove('visible');
            opener.setAttribute('aria-expanded', 'false');
            let optionSelected = false;
            options.forEach((opt: any) => {
                if (opt.selected) {
                    optionSelected = true;
                }
            });
            if (optionSelected) {
                selectionContainer.classList.remove('d-none');
            } else {
                selectionContainer.classList.add('d-none');
            }
            $select.dispatchEvent(new Event('change'));
            bindShowSelection(selectionContainer, options, panel);

            bindRemoveSingleSelection(panel, options, selectionContainer, $select);
        })
    }

    function bindReset(panel: any, options: any, selectionContainer: any, $select: any, opener: any) {
        const resetBtn = panel.querySelector('.buttons .reset-select');
        let fireEvent = false;

        resetBtn.addEventListener('click', () => {
            opener.classList.remove('open');
            panel.classList.remove('applied');
            panel.classList.remove('visible');
            opener.setAttribute('aria-expanded', 'false');
            selectionContainer.classList.add('d-none');
            options.forEach((option: any) => {
                if (option.selected) {
                    option.selected = false;
                    fireEvent = true;
                }
            });
            if (fireEvent) {
                $select.value = '';
                $select.dispatchEvent(new Event('change'));
            }
            const ticks = panel.querySelectorAll('.option-div');
            ticks.forEach((tick: any) => {
                tick.classList.remove('option-selected');
                tick.classList.remove('selected');
            })
            bindShowSelection(selectionContainer, options, panel)
        })
    }

    function bindRemoveSingleSelection(panel: any, options: any, selectionContainer: any, $select: any) {
        const selections = selectionContainer.querySelectorAll('.selection');
        selections.forEach((selection: any) => {
            const selectionId = selection.getAttribute('option-id');
            const deleteIcn = selection.querySelector('.delete-icn');

            deleteIcn.onclick = () => {
                const selectedItem = panel.querySelector(`.option-div[option-id="${selectionId}"]`);
                if (selectedItem) {
                    selectedItem.classList.remove('selected');
                    selectedItem.classList.remove('option-selected');
                    selectedItem.removeAttribute('aria-selected');
                    options.forEach((option: any) => {
                        if (option.value === selectionId) {
                            option.selected = false;
                        }
                    });
                }

                selection.remove();

                if (!selectionContainer.querySelectorAll('.selection').length) {
                    selectionContainer.classList.add('d-none');
                }

                $select.dispatchEvent(new Event('change'));
            }

            deleteIcn.onkeyup = (e: any) => {
                if (e.key === 'Enter') {
                    const selectedItem = panel.querySelector(`.option-div[option-id="${selectionId}"]`);
                    if (selectedItem) {
                        selectedItem.classList.remove('selected');
                        selectedItem.classList.remove('option-selected');
                        selectedItem.removeAttribute('aria-selected');
                        options.forEach((option: any) => {
                            if (option.value === selectionId) {
                                option.selected = false;
                            }
                        });
                    }

                    selection.remove();

                    if (!selectionContainer.querySelectorAll('.selection').length) {
                        selectionContainer.classList.add('d-none');
                    }

                    $select.dispatchEvent(new Event('change'));
                }
            }
        })
    }

    function isResetEnabled(options: any) {
        let value = false;
        options.forEach((option: any) => {
            if (option.selected) {
                value = true;
            }
        });

        return value;
    }

    function bindNextTab(panel: any, isMulti: boolean, opener: any, select: any) {
        const $options = panel.querySelectorAll('.option-div');

        if (isMulti) {
            panel.querySelector('input').addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key === 'Tab' && e.shiftKey) {
                    closePanel(panel, opener, select);
                }
            });

            opener.addEventListener('keyup', (e: KeyboardEvent) => {
                if (e.key === 'Tab') {
                    if (panel.classList.contains('visible') && !e.shiftKey) {
                        closePanel(panel, opener, select);
                    }
                }
            });

        } else {
            let optionsLength = $options.length;
            if (panel.querySelectorAll('.option-div[option-id="placeholder"]')) {
                optionsLength--;
            }
            $options.forEach(($option: any, index: number) => {
                $option.addEventListener('keydown', (e: KeyboardEvent) => {
                    if (e.key === 'Tab') {
                        if (!$options[index + 1] && !e.shiftKey) {
                            closePanel(panel, opener, select);
                        }

                        if (!$options[index - 1] && e.shiftKey) {
                            closePanel(panel, opener, select);
                        } 
                    }
                })
            })
        }
    }

    function closePanel(panel: any, opener: any, $select: any) {
        const input = panel.querySelector('input');
        const options = panel.querySelectorAll('.option-div');
        const applySelect = panel.querySelector('.apply-select');
        const resetSelect = panel.querySelector('.reset-select');
        const noResult = panel.querySelector('.no-result-el');
        const closeIcn = panel.querySelector('.close-icn');
        panel.classList.remove('visible');
        input?.setAttribute('disabled', '');
        applySelect?.setAttribute('disabled', '');
        resetSelect?.setAttribute('disabled', '');
        opener.setAttribute('aria-expanded', 'false');

        options.forEach((option: any) => {
            option.classList.remove('d-none');
            const tick = option.querySelector('.checkbox');
            if (tick) {
                tick.setAttribute('tabindex', '-1');
            } else {
                option.setAttribute('tabindex', '-1');
            }

            if (!panel.classList.contains('applied')) {
                option.classList.remove('option-selected');
                option.classList.remove('selected');
                $select.value = '';
            }
        });
        noResult?.classList.add('d-none');
        if (input) {
            input.value = '';
        }
        opener.classList.remove('open');
        panel.classList.remove('visible');
        panel.setAttribute('tabindex', '-1');
        clearInput(input, options);
        closeIcn?.setAttribute('tabindex', '-1');
        closeIcn?.classList.add('d-none');
        panel.classList.remove('visible');
        panel.removeAttribute('tabindex', '-1');
    }

    function bindArrowPanel(panel : any){
        const focusableEls = panel.querySelectorAll('.option-div');
        focusableEls.forEach((el : any, index : any) => {
            const tick = el.querySelector('.checkbox');

            if(tick){
                tick.addEventListener('keydown', (e: KeyboardEvent) => {
                    if(e.key === 'ArrowDown'){
                        e.preventDefault();
                        if(focusableEls[index + 1] && focusableEls[index + 1].querySelector('.checkbox').getAttribute('tabindex') === '0'){
                            focusableEls[index + 1].querySelector('.checkbox').focus();
                        }else if(focusableEls[index + 2]){
                            focusableEls[index + 2].querySelector('.checkbox').focus();
                        }
                    }
                    else if(e.key === 'ArrowUp'){
                        e.preventDefault();
                        if(focusableEls[index - 1] && focusableEls[index - 1].querySelector('.checkbox').getAttribute('tabindex') === '0'){
                            focusableEls[index - 1].querySelector('.checkbox').focus();
                        }else if(focusableEls[index - 2]){
                            focusableEls[index - 2].querySelector('.checkbox').focus();
                        }
                    }
                });
            }else{
                el.addEventListener('keydown', (e: KeyboardEvent) => {
                    if(e.key === 'ArrowDown'){
                        e.preventDefault();
                        if(focusableEls[index + 1] && focusableEls[index + 1].getAttribute('tabindex') === '0'){
                            focusableEls[index + 1].focus();
                        }else if(focusableEls[index + 2]){
                            focusableEls[index + 2].focus();
                        }
                    }
                    else if(e.key === 'ArrowUp'){
                        e.preventDefault();
                        if(focusableEls[index - 1] && focusableEls[index - 1].getAttribute('tabindex') === '0'){
                            focusableEls[index - 1].focus();
                        }else if(focusableEls[index - 2]){
                            focusableEls[index - 2].focus();
                        }
                    }
                });
            }

        });
    }

    function togglePanel(panel: any, selectOptions: any, buttonOpener: any, e: any, $options: any) {
        const optionWrapper = panel.querySelector('.option-wrapper');
        const options = optionWrapper.querySelectorAll('.option-div');
        const input = panel.querySelector('input');
        const applySelect = panel.querySelector('.apply-select');
        const resetSelect = panel.querySelector('.reset-select');
        if (panel.classList.contains('visible')) {
            buttonOpener.setAttribute('aria-expanded', 'false');
            if (selectOptions.isMulti) {
                input.setAttribute('disabled', '');
                applySelect.setAttribute('disabled', '');
                resetSelect.setAttribute('disabled', '');
                options.forEach((option: any) => {
                    const tick = option.querySelector('.checkbox');
                    tick.setAttribute('tabindex', '-1');
                })
            } else {
                options.forEach((option: any) => {
                    option.setAttribute('tabindex', '-1');
                })
            }
            buttonOpener.classList.remove('open');
            panel.classList.remove('visible');
            panel.setAttribute('tabindex', '-1');
        } else {
            buttonOpener.setAttribute('aria-expanded', 'true');
            panel.classList.add('visible');
            panel.setAttribute('tabindex', '0');
            panel.focus();
            if (selectOptions.isMulti) {
                options.forEach((option: any) => {
                    const tick = option.querySelector('.checkbox');
                    tick.setAttribute('tabindex', '0');
                    input.removeAttribute('disabled');
                    input.focus();
                    if (!e.pointerType) {
                        input.classList.remove('focus-mouse');
                    }

                    if (isResetEnabled($options)) {
                        applySelect.removeAttribute('disabled');
                        resetSelect.removeAttribute('disabled');
                    }
                })
            } else {
                options.forEach((option: any, index: number) => {
                    if(option.getAttribute('option-id') !== 'placeholder'){
                        option.setAttribute('tabindex', '0');
                    }
                });
            }
            buttonOpener.classList.add('open');
        }
    }

    export function init($select: any, index: any, selectOptions: SelectOptions = {}) {
        bindSelect($select, index, selectOptions);
    }

    export function update($selectContainer: any) {
        const $nativeSelect = $selectContainer.querySelector('select') as HTMLSelectElement;
        const $customSelect = $selectContainer.querySelector('.search-select__container') as HTMLElement;
        const $opener = $selectContainer.querySelector('.search-select__opener');

        const nativeValue = $nativeSelect.value;
        $opener.innerText = $nativeSelect.options[$nativeSelect.selectedIndex] ? $nativeSelect.options[$nativeSelect.selectedIndex].innerText : nativeValue;
        const $customOptions = $customSelect.querySelectorAll('.option-div');

        $customOptions.forEach($customOption => {
            const $tick = $customOption.querySelector('.checkbox');

            if ($tick) {

            } else {
                if ($customOption.getAttribute('option-id') === nativeValue) {
                    $customOption.setAttribute('aria-selected', 'true');
                    $customOption.classList.add('selected');
                } else {
                    $customOption.setAttribute('aria-selected', 'false');
                    $customOption.classList.remove('selected');
                }
            }
        })


    }

    $selects.forEach(($select, index) => {
        init($select, index);
    })

    expose('_multiCustomSelect', init);
}